module.exports = __webpack_public_path__ + "static/img/overlay-background.e3e50bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/overlay-background.jpg
// module id = uW/D
// module chunks = 18